<mat-checkbox color="primary" [formControl]="formControl">{{
  "ONSIP_I18N.VIDEO_CALLING_ENABLED" | translate
}}</mat-checkbox>
